import React from 'react';
import { BsSunFill, BsMoonFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { getTheme } from '../redux/selectors/appSelectors';
import { setDarkTheme, setLightTheme } from '../redux/slicers/app';

const ThemeToggle = () => {

  const dispatch = useDispatch();
  const theme = useSelector(getTheme)

  const handleChange = () => {
    if (theme === 'light') {
      dispatch(setDarkTheme())
    } else {
      dispatch(setLightTheme())
    }
  }

  return (
    <div className="toggle-switch" onClick={handleChange}>
      <div className={`slider ${theme === 'light' ? 'dark' : 'light'}`}>
        {theme === 'light' ? <BsSunFill color="white" /> : <BsMoonFill color="black" />}
      </div>
    </div>
  );
};

export default ThemeToggle;
